import React, { createContext, useCallback, useContext, useMemo, useState } from "react";

const LANGUAGE_STORAGE_KEY = "olt_front_lang";

const dictionaries = {
  fr: {
    nav_home: "Accueil",
    nav_storage: "Storage",
    nav_admin: "Admin",
    login_title: "Reporting PDF",
    login_gate_text: "Veuillez vous connecter pour acceder au reporting PDF",
    login: "Connexion",
    logout: "Deconnexion",
    user_menu: "Menu utilisateur",
    not_connected: "Non connecte",
    please_login: "Veuillez vous connecter pour acceder a l'application.",
    company_label: "Entreprise",
    no_role: "Aucun role",
    dark_mode: "Mode sombre",
    light_mode: "Mode clair",
    language_fr: "Francais",
    language_en: "English",
    refresh: "Rafraichir",
    loading: "Chargement...",
    executions: "Executions",
    no_execution: "Aucune execution pour le moment.",
    clear_list: "Vider la liste",
    deleting: "Suppression...",
    add_queue: "Ajouter a la file",
    add_in_progress: "Ajout en cours",
    selected_templates: "Templates selectionnes :",
    select_templates: "Selectionner les templates",
    select_client: "Selectionner un client",
    select_client_first: "Choisissez d'abord un client",
    select_pdf: "Selectionner un PDF",
    add_pdf: "Ajouter le PDF",
    period: "Periode",
    client: "Client",
    status: "Statut",
    waiting: "En attente",
    cancel: "Annuler",
    retry_download: "Reessayer le telechargement",
    downloading: "Telechargement...",
    delete: "Supprimer",
    eta_calculating: "ETA en calcul...",
    eta_prefix: "ETA ~",
    server_capacity_loading: "Chargement capacite...",
    server_capacity_unavailable: "Capacite indisponible",
    server_executions_in_progress: "executions en cours",
    running: "en cours",
    queued: "en file",
    max_capacity: "capacite max",
    report_ready: "Rapport pret",
    report_generated_with_missing_images: "Rapport genere avec des images manquantes",
    admin_title: "Administration - Executions serveur",
    search_user: "Rechercher un utilisateur...",
    all_statuses: "Tous les statuts",
    all_clients: "Tous les clients",
    all_templates: "Tous les templates",
    details: "Details",
    view: "Voir",
    hide: "Masquer",
    open: "Ouverture...",
    stop: "Stop",
    stop_in_progress: "Arret...",
    no_admin_execution: "Aucune execution trouvee.",
    user: "Utilisateur",
    progress: "Progression",
    action: "Action",
    start_period: "Periode debut",
    end_period: "Periode fin",
    created_at: "Cree le",
    completed_at: "Termine le",
    download_pdf: "Telecharger le PDF",
    job_source: "Source",
    warnings: "Warnings",
    warnings_present: "Warnings presentes",
    error_code: "Code erreur",
    error_message: "Message erreur",
    email_recipients: "Destinataires email",
    failed_email_recipients: "Destinataires email en echec",
    email_delivery: "Envoi email",
    email_sent: "Envoye",
    email_failed: "Echec",
    email_delivered: "Delivre",
    email_bounced: "Rejete (bounce)",
    email_no_recipient: "Aucun destinataire",
    resend: "Renvoyer",
    resend_in_progress: "Envoi...",
    resend_confirm: "Renvoyer le rapport par email aux destinataires suivants ?",
    resend_all_recipients: "Tous les destinataires",
    resend_failed_job_note: "Ce rapport est en échec : le renvoi n'est possible que si le PDF avait été généré avant l'erreur.",
    email_status_detail: "Statut des envois",
    sent_at: "Envoye a",
    storage_title: "Bibliotheque PDF",
    storage_admin_description: "Retrouvez tous les PDF finalises et ouvrez-les rapidement par client, periode ou utilisateur.",
    storage_user_description: "Retrouvez tous les PDF finalises de votre societe dans une vue simple et plus lisible.",
    storage_documents_label: "PDF disponibles",
    storage_search_admin: "Rechercher par client, document, utilisateur ou periode...",
    storage_search_user: "Rechercher par document ou periode...",
    storage_empty_title: "Aucun PDF disponible",
    storage_empty_text: "Les PDF finalises apparaitront ici des qu'ils seront prets.",
    storage_available_date: "Disponible le",
    storage_load_error: "Impossible de charger la bibliotheque PDF.",
    storage_open_error: "Impossible d'ouvrir le PDF.",
    storage_status_ok: "Sans erreur",
    storage_status_warning: "Avec erreurs",
    dates: "Dates",
    nav_coordinator: "Coordinator",
    nav_templates: "Templates",
    templates_title: "Gestion des templates PDF",
    templates_description: "Configurez les clients Grafana et leurs parametres de connexion pour la generation de rapports.",
    templates_count_label: "templates",
    templates_key_hint: "laisser vide pour ne pas changer",
    templates_tpl_name: "Nom du template",
    templates_no_logo: "Aucun logo trouve pour ce client",
    templates_logo: "Logo client",
    templates_drop_logo: "Glisser une image ici ou cliquer",
    templates_enter_name_first: "Saisissez un nom de client",
    templates_browse: "Parcourir",
    coord_active: "Actifs",
    coord_daily: "Quotidien",
    coord_weekly: "Hebdomadaire",
    coord_monthly: "Mensuel",
    coord_add_client: "Ajouter un client",
    coord_edit_client: "Modifier le client",
    coord_search: "Rechercher par client, template ou email...",
    coord_all_triggers: "Tous les triggers",
    coord_status_col: "Statut",
    coord_next_exec: "Prochaine execution",
    coord_recipients: "destinataire(s)",
    coord_no_client: "Aucun client configure.",
    coord_on: "ON",
    coord_off: "OFF",
    coord_activate: "Activer",
    coord_deactivate: "Desactiver",
    coord_edit: "Modifier",
    coord_save: "Enregistrer",
    coord_create: "Creer",
    coord_email_hint: "separes par des virgules",
    coord_err_name: "Le nom du client est requis",
    coord_err_template: "Le template est requis",
    coord_err_email: "Au moins un email est requis",
    coord_err_dashboard: "L'URL du dashboard est requise",
    coord_err_report_name: "Le nom du rapport est requis",
    coord_err_client_template_match: "Aucun template ne correspond a ce client. Configurez-le dans la page Templates.",
    coord_load_error: "Impossible de charger les clients coordinator.",
    coord_dashboard_url: "URL Dashboard",
    coord_report_name: "Nom du rapport",
    coord_select_report_name: "Selectionner un rapport",
    coord_no_template_for_client: "Aucun template configure pour ce client",
    coord_search_new: "Rechercher par client, rapport ou email...",
    clients_title: "Gestion des clients Grafana",
    clients_add: "Ajouter un client",
    clients_edit: "Modifier le client",
    clients_grafana_url: "URL Grafana",
    clients_api_key: "Cle API Grafana",
    clients_email_ext: "Domaine email",
    clients_roles: "Roles",
    clients_roles_hint: "separes par des virgules",
    clients_err_name: "Le nom du client est requis",
    clients_err_grafana_url: "L'URL Grafana est requise",
    clients_load_error: "Impossible de charger les clients.",
    clients_no_client: "Aucun client configure.",
    clients_save: "Enregistrer",
    clients_create: "Creer",
  },
  en: {
    nav_home: "Home",
    nav_storage: "Storage",
    nav_admin: "Admin",
    login_title: "PDF Reporting",
    login_gate_text: "Please sign in to access PDF reporting",
    login: "Sign in",
    logout: "Sign out",
    user_menu: "User menu",
    not_connected: "Not connected",
    please_login: "Please sign in to access the app.",
    company_label: "Company",
    no_role: "No role",
    dark_mode: "Dark mode",
    light_mode: "Light mode",
    language_fr: "French",
    language_en: "English",
    refresh: "Refresh",
    loading: "Loading...",
    executions: "Executions",
    no_execution: "No execution for now.",
    clear_list: "Clear list",
    deleting: "Deleting...",
    add_queue: "Add to queue",
    add_in_progress: "Adding...",
    selected_templates: "Selected templates:",
    select_templates: "Select templates",
    select_client: "Select a client",
    select_client_first: "Choose a client first",
    select_pdf: "Select a PDF",
    add_pdf: "Add PDF",
    period: "Period",
    client: "Client",
    status: "Status",
    waiting: "Waiting",
    cancel: "Cancel",
    retry_download: "Retry download",
    downloading: "Downloading...",
    delete: "Delete",
    eta_calculating: "ETA calculating...",
    eta_prefix: "ETA ~",
    server_capacity_loading: "Loading capacity...",
    server_capacity_unavailable: "Capacity unavailable",
    server_executions_in_progress: "running executions",
    running: "running",
    queued: "queued",
    max_capacity: "max capacity",
    report_ready: "Report ready",
    report_generated_with_missing_images: "Report generated with missing images",
    admin_title: "Administration - Server executions",
    search_user: "Search user...",
    all_statuses: "All statuses",
    all_clients: "All clients",
    all_templates: "All templates",
    details: "Details",
    view: "View",
    hide: "Hide",
    open: "Opening...",
    stop: "Stop",
    stop_in_progress: "Stopping...",
    no_admin_execution: "No execution found.",
    user: "User",
    progress: "Progress",
    action: "Action",
    start_period: "Start period",
    end_period: "End period",
    created_at: "Created at",
    completed_at: "Completed at",
    download_pdf: "Download PDF",
    job_source: "Source",
    warnings: "Warnings",
    warnings_present: "Warnings present",
    error_code: "Error code",
    error_message: "Error message",
    email_recipients: "Email recipients",
    failed_email_recipients: "Failed email recipients",
    email_delivery: "Email delivery",
    email_sent: "Sent",
    email_failed: "Failed",
    email_delivered: "Delivered",
    email_bounced: "Bounced",
    resend: "Resend",
    resend_in_progress: "Sending...",
    resend_confirm: "Resend the report email to the following recipients?",
    resend_all_recipients: "All recipients",
    resend_failed_job_note: "This report failed: it can only be resent if the PDF was generated before the error.",
    email_no_recipient: "No recipient",
    email_status_detail: "Delivery status",
    sent_at: "Sent at",
    storage_title: "PDF Library",
    storage_admin_description: "Browse every completed PDF and open it quickly by client, period, or user.",
    storage_user_description: "Browse every completed PDF available for your company in a simpler, easier-to-scan library view.",
    storage_documents_label: "available PDFs",
    storage_search_admin: "Search by client, document, user, or period...",
    storage_search_user: "Search by document or period...",
    storage_empty_title: "No PDF available",
    storage_empty_text: "Completed PDFs will appear here as soon as they are ready.",
    storage_available_date: "Available on",
    storage_load_error: "Failed to load the PDF library.",
    storage_open_error: "Failed to open the PDF.",
    storage_status_ok: "No errors",
    storage_status_warning: "With errors",
    dates: "Dates",
    nav_coordinator: "Coordinator",
    nav_templates: "Templates",
    templates_title: "PDF Template Management",
    templates_description: "Configure Grafana clients and their connection settings for report generation.",
    templates_count_label: "templates",
    templates_key_hint: "leave empty to keep unchanged",
    templates_tpl_name: "Template name",
    templates_no_logo: "No logo found for this client",
    templates_logo: "Client logo",
    templates_drop_logo: "Drop an image here or click",
    templates_enter_name_first: "Enter a client name first",
    templates_browse: "Browse",
    coord_active: "Active",
    coord_daily: "Daily",
    coord_weekly: "Weekly",
    coord_monthly: "Monthly",
    coord_add_client: "Add client",
    coord_edit_client: "Edit client",
    coord_search: "Search by client, template or email...",
    coord_all_triggers: "All triggers",
    coord_status_col: "Status",
    coord_next_exec: "Next execution",
    coord_recipients: "recipient(s)",
    coord_no_client: "No client configured.",
    coord_on: "ON",
    coord_off: "OFF",
    coord_activate: "Activate",
    coord_deactivate: "Deactivate",
    coord_edit: "Edit",
    coord_save: "Save",
    coord_create: "Create",
    coord_email_hint: "separated by commas",
    coord_err_name: "Client name is required",
    coord_err_template: "Template is required",
    coord_err_email: "At least one email is required",
    coord_err_dashboard: "Dashboard URL is required",
    coord_err_report_name: "Report name is required",
    coord_err_client_template_match: "No matching template for this client. Configure it in the Templates page.",
    coord_load_error: "Failed to load coordinator clients.",
    coord_dashboard_url: "Dashboard URL",
    coord_report_name: "Report name",
    coord_select_report_name: "Select a report",
    coord_no_template_for_client: "No template configured for this client",
    coord_search_new: "Search by client, report or email...",
    clients_title: "Grafana Client Management",
    clients_add: "Add client",
    clients_edit: "Edit client",
    clients_grafana_url: "Grafana URL",
    clients_api_key: "Grafana API Key",
    clients_email_ext: "Email domain",
    clients_roles: "Roles",
    clients_roles_hint: "separated by commas",
    clients_err_name: "Client name is required",
    clients_err_grafana_url: "Grafana URL is required",
    clients_load_error: "Failed to load clients.",
    clients_no_client: "No client configured.",
    clients_save: "Save",
    clients_create: "Create",
  },
};

function resolveInitialLanguage() {
  if (typeof window === "undefined") {
    return "fr";
  }
  const stored = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);
  if (stored === "fr" || stored === "en") {
    return stored;
  }
  return "fr";
}

const I18nContext = createContext({
  language: "fr",
  setLanguage: () => {},
  t: (key) => key,
});

export function I18nProvider({ children }) {
  const [language, setLanguage] = useState(resolveInitialLanguage);

  React.useEffect(() => {
    if (typeof window !== "undefined") {
      window.localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
    }
  }, [language]);

  const setAndPersistLanguage = useCallback((nextLanguage) => {
    const safeLanguage = nextLanguage === "en" ? "en" : "fr";
    setLanguage(safeLanguage);
  }, []);

  const t = useCallback(
    (key) => dictionaries[language]?.[key] || dictionaries.fr[key] || key,
    [language]
  );

  const value = useMemo(
    () => ({ language, setLanguage: setAndPersistLanguage, t }),
    [language, setAndPersistLanguage, t]
  );

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  return useContext(I18nContext);
}
